module.exports = __webpack_public_path__ + "static/media/ok.dc3a3b6a.svg";